import React from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
// import ComboInputPeriod from "../../components/inputs/ComboInputPeriod";
import ComboInputPeriodV2 from "../inputs/ComboInputPeriodV2";

const DateStatisticsSearchBox = ({
                                   searchParam,
                                   setSearchParam,
                                   updateList,
                                   setCurrentPage
                                 }) => {

  const onChangeStartDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, startDate: date};
    });
  };

  const onChangeEndDate = (date) => {
    setSearchParam((prev) => {
      return {...prev, endDate: date};
    });
  };

  const onChangeSearchStatsTy = (e) => {
    setSearchParam((prev) => {
      return {...prev, searchStatsTy: e.target.value};
    });
  };

  const onClickSearch = (e) => {
    e.preventDefault();
    updateList();
    setCurrentPage(1);
  };


  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            onSubmit={onClickSearch}
        >
          <Row className={"justify-content-center"}>
            <Col md={12}>
              <Row className={"text-center"}>
                <Col md={10}>
                  <Row className={"gy-2"}>
                    {/*<Col md={5} className={""}>*/}
                    <Col xxl={6} xl={12} lg={12} md={12}>
                      <ComboInputPeriodV2
                          propSearchParam={searchParam}
                          propOnChangeStart={onChangeStartDate}
                          propOnChangeEnd={onChangeEndDate}
                      />
                    </Col>

                    {/*<Col md={3} className={""}>*/}
                    <Col xxl={3} xl={6} lg={6} md={12}>
                      <Form.Group as={Row} controlId="formBasicSelectMenu">
                        <Form.Label
                            className={`col-form-label label text-end`}
                            style={{width: "100px"}}
                        >
                          통계유형
                        </Form.Label>
                        <Col>
                          <Form.Select
                              aria-label="Default select example"
                              className={"input-select"}
                              onChange={onChangeSearchStatsTy}
                              defaultValue={searchParam.searchStatsTy}
                          >
                            <option value={""}>전체</option>
                            <option value={"WEB"}>웹응답성능</option>
                            <option value={"DB"}>DB응답성능</option>
                          </Form.Select>
                        </Col>
                      </Form.Group>
                    </Col>

                  </Row>
                </Col>
                <Col md={2} className={"text-center search-btn-container d-flex align-items-center justify-content-center"}>
                  <Button
                      type="submit"
                      className={"search-btn"}
                      style={{width: "100px"}}
                  >
                    검색
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </>
  );
};

export default DateStatisticsSearchBox;
